export default __webpack_public_path__ + "static/media/KOD0119-min.9bfc1530.webp";